import { getUsers } from "../../controllers/ExcursionController";
import React, { useState, useEffect } from "react";


function UsersList({ id }) {
    const  [users, setUsers] = useState([]);
    useEffect(() => {
        getUsers(id)
            .then((data) => {
                console.log("API Response:", data);
                setUsers(data);
            })
            .catch((error) => {
                console.error("Error fetching users data:", error);
                setUsers([]);
            });
    }, [id]);
    return (
        <div className="UsersList">
            <h3>Liste des participants</h3>
            <ul>
                {users.length > 0 ? (
                    users.map((user, index) => (
                        <li key={index}>
                            <p>{user.username}</p>
                        </li>
                    ))
                ) : (
                    <p className=".no-participants">Aucun participant</p>
                )}
            </ul>
        </div>
    );
}

export default UsersList;